<template>
  <vue-seamless-scroll
    :data="listData"
    :class-option="classOption"
    class="warp"
  >
    <ul class="ul-item">
      <li class="li-item" v-for="item in listData" :key="item.ID">
        <!-- {{ item }} -->
        <img :src="item.ImgUrl" alt="">
      </li>
    </ul>
  </vue-seamless-scroll>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'Example03Basic',
  components: {
    vueSeamlessScroll
  },
  computed: {
    listData () {
      return this.$store.state.aboutFellows
    }

  },
  data () {
    return {
      classOption: {
        limitMoveNum: 2,
        direction: 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
  .warp>div {width: 1400px/$md !important;}
  .warp {
    width: 1400px/$md;
    height: 90px/$md;
    margin: 0;
    overflow: hidden;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      &.ul-item {
        display: flex;
        .li-item {
          width: 173px/$md;
          height: 90px/$md;
          margin-right: 30px/$md;
        //   line-height: 120px/$md;
          background-color: #999;
          color: #fff;
          text-align: center;
          font-size: 30px/$md;
          float: left;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
</style>
